export default [
  {
    code: "08-0039",
    size: "370x450",
    color: "envelopesProperties.color.brown",
    boxSize: 250,
  },
]
